import React from 'react'
import textStyle from "../components/css/textStyle.module.scss";

export default function({children, subtitle, theme, processHTML, footerImg, highlightText}){
     if(theme=="dark")
    {
        theme = textStyle.dark
    }

    let containerClass = false;
    if(highlightText)
    {
        containerClass = textStyle.hasHighlightText
    }
    return (
        
            children ? <div className={textStyle.wrapper + " " +containerClass}>
                        {
                            highlightText && <span>{highlightText}</span>
                        }    
                        <div className={"textcontent " +textStyle.container+ " "+ theme}>
                           {
                               subtitle && <h1>{subtitle}</h1>
                           }
                        { processHTML ? <div dangerouslySetInnerHTML={{__html: children}}></div> : children}
                       
                        </div> { footerImg ? <img src={"/assets/"+footerImg} className={textStyle.footerImg} /> : "" }</div> : <div></div>
        
        
    )
}